<template>
    <div id="form" class="centralize" v-if="form_url != null">
        <iframe
            height="680px"
            width="420px"
            :src="form_url"
            title="Formulario"
        ></iframe>
    </div>
</template>

<script>
    import { User } from '../../models/User';
import { REQUEST_FORM } from '../../services/formBuilder';

    export default {
        name: "NewFormBuilder",
        props: ['next', 'kit_number'],
        components: {},
        data: () => ({
            form_url: null,
        }),
        mounted() {
            this.windowListener();
            this.requestForm();
        },
        methods: {
            async requestForm() {
                let user = new User();
                const data = await REQUEST_FORM({
                    name: user.getUser(),
                    birth_date: user.getBirthdate(),
                    id: this.kit_number,
                    formbuilder_tag: 'anamnese_litio'
                });
                
                this.form_url = data.form;
            },
            formFinished() {
                console.log("hey hey hey");
                this.$emit('next');
            },
            windowListener() {
                const goToFinishedForm = () => {
                    this.formFinished();
                }
                window.addEventListener("message", function (message) {
                    const { data: messageData } = message;
                    if (messageData.success && messageData.type === "formFinished") goToFinishedForm()
                });
            }
        },
    }
</script>

<style lang="css">
    .centralize {
        display: flex;
        justify-content: center;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/NewFormBuilder/NewFormBuilder.vue